module.exports = __webpack_public_path__ + "img/ThreeAxleTractorTwoAxleSemitrailer.1fce7bba.svg";